<template>
  <div class="flex items-center gap-1" role="group" :aria-label="label">
    <span class="me-1 text-[10px] font-bold uppercase tracking-widest text-[#1c4848]/45">{{ label }}</span>
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="min-h-8 rounded-md px-2 text-[11px] font-bold transition-colors"
      :class="value === option.value ? 'bg-[#1c4848] text-white' : 'text-[#1c4848]/60 hover:bg-[#1c4848]/5'"
      :aria-pressed="value === option.value"
      @click="$emit('pick', option.value)"
    >{{ option.label }}</button>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: String, default: '' },
  options: { type: Array, required: true },
});
defineEmits(['pick']);
</script>
